<template>
  <div class="all-work-order">
    <el-button type="primary" @click="exportToWord"
      >导出全部工单信息表</el-button
    >
    <!-- 后续可以作为页面，管理要导出的内容 -->
  </div>
</template>

<script>
import { exportWorkOrdersToWord, imageToBase64 } from "./test1";
import WorkOrderApi from "@/api/workOrder";

export default {
  name: "AllWorkOrder",
  data() {
    return {
      allWorkOrders: [],
    };
  },
  methods: {
    // 将原始图片 URL 转换为代理 URL（如果需要）
    getProxyImageUrl(originalUrl) {
      if (!originalUrl) return "";
      
      // 如果你的后端有代理接口，取消下面的注释并修改为你的代理地址
      // return `/api/proxy/image?url=${encodeURIComponent(originalUrl)}`;
      
      // 暂时直接返回原始 URL
      return originalUrl;
    },

    // 获取所有工单数据
    async fetchAllWorkOrders() {
      try {
        // 获取所有工单，设置足够大的size参数以获取全部数据
        const res = await WorkOrderApi.queryPage({
          current: 0,
          size: 10000, // 获取所有数据
        });

        if (res.data.code === 200) {
          this.allWorkOrders = res.data.data.records;
          return this.allWorkOrders;
        } else {
          this.$message.error(res.data.message || "获取工单数据失败");
          return [];
        }
      } catch (error) {
        this.$message.error("获取工单数据失败");
        console.error(error);
        return [];
      }
    },

    // 状态值转换为文本
    getStatusText(status) {
      if (status === 0) return "待分配";
      if (status === 1) return "进行中";
      if (status === 2) return "已完成";
      if (status === 3) return "已撤回";
      if (status === 4) return "已作废";
      return "";
    },

    // 获取工单详情
    async fetchWorkOrderDetail(id) {
      try {
        const res = await WorkOrderApi.workOrderDetail({ id });
        if (res.data.code === 200) {
          return res.data.data;
        } else {
          this.$message.error(res.data.message || "获取工单详情失败");
          return null;
        }
      } catch (error) {
        this.$message.error("获取工单详情失败");
        console.error(error);
        return null;
      }
    },

    

    // 导出为Word文档
    async exportToWord() {
      this.$message.info("正在导出工单数据...");

      // 获取所有工单数据
      const workOrders = await this.fetchAllWorkOrders();

      if (!workOrders || workOrders.length === 0) {
        this.$message.warning("没有工单数据可导出");
        return;
      }

      console.log("开始导出工单，总数:", workOrders.length);

      // 格式化工单数据
      const formattedWorkOrders = await Promise.all(
        workOrders.map(async (order, index) => {
          // 获取工单详情
          const workOrderDetail = await this.fetchWorkOrderDetail(order.id);
          const orderVo = workOrderDetail ? workOrderDetail.orderVo : null;

          // 获取图片URL并转换为base64
          let photoUrl = "";
          if (orderVo && orderVo.photoUrl) {
            console.log(`工单 ${index + 1} - 图片URL:`, orderVo.photoUrl);
            try {
              photoUrl = await imageToBase64(orderVo.photoUrl);
              if (photoUrl && photoUrl.startsWith('data:image/')) {
                console.log(`工单 ${index + 1} - ✅ 图片转换成功`);
              } else {
                console.warn(`工单 ${index + 1} - ❌ 图片转换失败`);
              }
            } catch (error) {
              console.error(`工单 ${index + 1} - 图片转换异常:`, error);
              photoUrl = "";
            }
          }

          // 返回格式化后的数据
          return {
            index: index + 1,
            projectName: order.projectName || "",
            roadName: order.roadName || "",
            type: order.type || "",
            deadline: order.deadline || "",
            description: order.description || "",
            createTime: order.createTime || "",
            applyName: orderVo ? orderVo.applyName || "" : "",
            id: order.id || "",
            managerName: order.managerName || "",
            statusText: this.getStatusText(order.status),
            photoUrl: photoUrl,
          };
        }),
      );

      console.log("工单数据处理完成，准备导出");

      try {
        // 调用test1.js中的导出函数
        await exportWorkOrdersToWord(formattedWorkOrders);
        this.$message.success("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.all-work-order {
  padding: 24px;
}
</style>
